// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3gmTK","errors":"Errors_errors__2zxch"};